import { Link } from 'react-router-dom';
import type { TermsState } from '../hooks/useTerms';
import DraftTag from './DraftTag';

interface Props {
  readonly state: TermsState;
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
  readonly disabled?: boolean;
}

/**
 * The acceptance of the Terms and Conditions (0181), the first box of the screen a client reaches
 * after signing in: a link to the full text (opens in a new tab) and a box the person ticks
 * themselves, apart from the privacy notice's. While the terms are a placeholder the line says
 * so. When they cannot be read the box is not offered: a page that cannot show the text cannot
 * take the acceptance.
 */
export default function TermsConsent({
  state,
  checked,
  onChange,
  disabled = false,
}: Props): JSX.Element {
  if (state.unavailable) {
    return (
      <p role="alert" className="text-xs" style={{ color: '#DC2626' }}>
        The Terms and Conditions are not available right now. Please try again later.
      </p>
    );
  }
  return (
    <label className="flex items-start gap-2 text-sm" style={{ color: '#374151' }}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled || state.terms === null}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1"
      />
      <span>
        I accept the{' '}
        <Link to="/terms" target="_blank" rel="noreferrer" className="underline">
          Terms and Conditions
        </Link>
        .{state.terms?.is_draft && <DraftTag />}
      </span>
    </label>
  );
}
